module.exports = __webpack_public_path__ + "media/svg/cnbc-6b8ee56b.svg";